import { throwError } from "@/lib/throwError";
import { del, get, post, put } from "@/services/axiosUitils";
import {
  CreateUserRolePayload,
  MyPermission,
  RoleList,
  UpdateUserRolePayload,
  UserRole,
} from "@/utils/types/tenantPermissions";

const userRolesBase = "/api/tenant-permissions/user-roles/";

interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

class TenantUserRoleService {
  listUserRoles = async (
    page = 1,
    pageSize = 20
  ): Promise<PaginatedResponse<UserRole>> => {
    return await get<PaginatedResponse<UserRole>>(userRolesBase, {
      params: { page, page_size: pageSize },
    });
  };

  getUserRoleById = async (id: string): Promise<UserRole> => {
    if (!id) {
      throwError("ID is required", "TenantUserRoleService");
    }
    return await get<UserRole>(`${userRolesBase}${id}/`);
  };

  createUserRole = async (
    payload: CreateUserRolePayload
  ): Promise<UserRole> => {
    if (!payload) {
      throwError("Payload is required", "TenantUserRoleService");
    }
    return await post<UserRole>(userRolesBase, payload);
  };

  updateUserRole = async (
    id: string,
    payload: UpdateUserRolePayload
  ): Promise<UserRole> => {
    if (!id || !payload) {
      throwError("ID and payload are required", "TenantUserRoleService");
    }
    return await put<UserRole>(`${userRolesBase}${id}/`, payload);
  };

  deleteUserRole = async (id: string): Promise<any> => {
    if (!id) {
      throwError("ID is required", "TenantUserRoleService");
    }
    return await del(`${userRolesBase}${id}/`);
  };

  getMyPermissions = async (): Promise<MyPermission[]> => {
    return await get<MyPermission[]>(`${userRolesBase}my_permissions/`);
  };

  getRoleListByUserId = async (userId: string): Promise<string[]> => {
    const response = await get(`${userRolesBase}roles_by_user/`, {
      params: { user_id: userId },
    });
    return response.roles;
  };

  postRoleListByUserId = async (
    userId: string,
    payload: RoleList
  ): Promise<RoleList[]> => {
    const response = await put(`${userRolesBase}roles_by_user/`, payload, {
      params: { user_id: userId },
    });
    return response.roles;
  };
}

const instance = new TenantUserRoleService();
export default instance;
